import InvoiceService from '@/api/InvoiceService'

// initial state
const state = {
  invoices: [],
  invoice: null,
  nextInCode: null,
}

// getters
const getters = {
  getInvoices: state => state.invoices,
  getInvoice: state => state.invoice,
  getNextInCode: state => state.nextInCode,
  getInvoiceStatus: (state) => (invoice, $t, mixin) => {
    let debtAmount = mixin.getDebtInvoiceAmount(invoice)
    let isPaid = true

    // end this line if this po has rejected
    if (invoice.status == 'rejected') {
      return {
        message: $t('status.in.rejected'),
        status: 'rejected',
      }
    }
    // end this line if this po is padding
    if (invoice.status == 'padding') {
      return {
        message: $t('status.in.padding'),
        status: 'padding',
      }
    }

    // set value
    if (invoice.reference.payments.length == 0) {
      isPaid = false
    } else {
      for (let i in invoice.reference.payments) {
        if (invoice.reference.payments[i].status != 'paid') {
          isPaid = false
        }
      }
      if (debtAmount > 0) {
        isPaid = false
      }
    }
    // set value ended

    if (!isPaid) {
      return {
        message: $t('status.in.topay'),
        status: 'uncompleted',
      }
    }

    return {
      message: $t('status.in.completed'),
      status: 'completed',
    }
  },
  getInvoiceInfo: (state) => (in_id) => {
    return state.invoices.find(inv => inv.in_id == in_id)
  },
}

// mutations
const mutations = {
  setInvoices (state, data) {
    state.invoices = data
  },
  setInvoice (state, data) {
    state.invoice = data
  },
  setNextInCode (state, data) {
    state.nextInCode = data
  },
  updateInvoiceStatus (state, data) {
    if (state.invoice) {
      if (state.invoice.in_id == data.in_id) {
        state.invoice.status = data.status
      }
    }
    if (state.invoices.length > 0) {
      state.invoices.map((p, idx) => {
        if (p.in_id == data.in_id) {
          return p.status = data.status
        }
      })
    }
  },
  updateInvoicePaymentStatus (state, data) {
    if (state.invoice) {
      state.invoice.reference.payments.map(payment => {
        if (payment.pe_id == data.pe_id) {
          payment.status = data.status
        }
      })
    }
  },
}

// actions
const actions = {
  async getInvoices ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getInvoices') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getInvoices')

      let response = await InvoiceService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getInvoices')

      result = response.data

      if (result.success) {
        commit('setInvoices', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearInvoices ({ commit }) {
    commit('setInvoices', [])
  },
  async getInvoice ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getInvoice') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getInvoice')

      let response = await InvoiceService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getInvoice')

      result = response.data

      if (result.success) {
        if (result.data.length > 0) {
          commit('setInvoice', result.data[0])
        } else {
          // not found data
          this.dispatch('Error', 'Not found data')
        }
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearInvoice ({ commit }) {
    commit('setInvoice', null)
  },
  async insertInvoice ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await InvoiceService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getNextInCode ({ commit }) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getNextInCode') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getNextInCode')

      let response = await InvoiceService.getLatestCode()

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getNextInCode')

      result = response.data

      if (result.success) {
        commit('setNextInCode', result.data.next)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteInvoice ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await InvoiceService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateInvoice ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await InvoiceService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateInvoiceStatus ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await InvoiceService.updateStatus(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('updateInvoiceStatus', data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  updateInvoicePaymentStatus ({ commit }, data) {
    commit('updateInvoicePaymentStatus', data)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Invoice.js